import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";
//oldest page
const Coin = () => {
	useEffect(() => {
		document.title = "Coin Change (Change-making problem)";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("77"); //int
	const [guiTxt2, guiTxtChange2] = useState("63,55,48,41,30,29,17,15,12,8,1");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	//https://www.geeksforgeeks.org/coin-change-dp-7/
	// function buttonClick1 () {
	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			var coins = T.str_toListInt(guiTxt2);
			var target = parseInt(guiTxt1);
			Timer.start();
			process(coins, target);
			txt_time = Timer.stop_print();
			BuildResult();
			//clear ------------
			optimalSolution = [];
			memory_n = null;
			memory_set = null;
		}
	};

	var txt_time = "";
	var way = 0;
	var optimalSolution = [];
	//Parallel, index is target value
	var memory_n; //int # of coin needed
	var memory_set; //List<int> set of coin

	function process(coins, target) {
		way = getNumberOfWays(target, coins);
		console.log("# of WAY " + way);
		if (way > 0) {
			findCoins(coins, target);
		}
	}

	//NEW solution -----------
	const getNumberOfWays = (N, Coins) => {
		// Create the ways array to 1 plus the amount to stop overflow
		let ways = new Array(N + 1);
		for (let i = 0; i < N + 1; i++) {
			ways[i] = 0;
		}
		// Set the first way to 1 because its 0 and there is 1 way to make 0 with 0 coins
		ways[0] = 1;
		// Go through all of the coins
		for (let i = 0; i < Coins.length; i++) {
			// Make a comparison to each index value of ways with the coin value.
			for (let j = 0; j < ways.length; j++) {
				if (Coins[i] <= j) {
					ways[j] += ways[j - Coins[i]];
				}
			}
		}
		return ways[N];
	};

	//---------

	//int[] coins, int target
	function findCoins(coins, target) {
		var listCoins = T.listSort_desc(coins); //Arrays.sort(coins, Collections.reverseOrder());//biggest coin first
		// console.log("COIN " + listCoins);
		// listSolutions = []; //List<ArrayList<Integer>> all = new ArrayList<ArrayList<Integer>>();//Each item = possible set of coins
		optimalSolution = [];
		memory_n = new Array(target + 1).fill(0);
		memory_set = new Array(target + 1).fill([]);
		recur_addCoin([], listCoins, 0, target); //List<ArrayList<Integer>> all;//Each item = possible set of coins
	}

	//This function not return
	//INPUT: list of coin now, list of all coins (sorted High to Low), amount remain
	//List<ArrayList<Integer>> all, ArrayList<Integer> list, Integer[] coins, int remain
	//coin_i help skipping too large coin (next coin but not larger than last coin the list)
	function recur_addCoin(list, coins, coin_i, remain) {
		if (Timer.timeout()) {
			return;
		}
		//check remain amount in memory ----------------------------
		var opt_n = memory_n[remain];
		// console.log("test " + opt_n + " vs " + list.length);
		if (remain < 0) {
			return;
		}
		if (remain != 0) {
			if (opt_n < 0) {
				return; //unreachable
			}
			if (opt_n > 0) {
				// found data
				list.push(memory_set);
				remain = 0;
				console.log("call " + list);
			}
		}
		if (remain == 0) {
			// console.log("Found " + list + " size " + list.length);
			if (optimalSolution.length == 0 || list.length < optimalSolution.length) {
				// console.log("SET");
				console.log("BEST " + list + " size " + list.length);
				optimalSolution = list; //reach target, return this set
			}

			memorize(list);
			// found = true;
		}
		//---------------------------------------------------------
		// if(opt > 0 && opt < list.length - 2){ console.log("SKIP"); return; }
		// console.log("GO ON");
		var found = false;
		for (var c = coin_i; c < coins.length; c++) {
			var x = coins[c];
			if (x <= remain) {
				var lastCoin = list[list.length - 1];
				if (list.length == 0 || x <= lastCoin) {
					//only if list is empty, or this coin is not bigger than the last coin
					var list_new = T.listAdd(list, coins[c]);
					var left = remain - coins[c];
					// console.log("REMAIN " + remain + "-" + coins[c] + " >> " + left);
					//--------------------------------
					if (left == 0) {
						// console.log("Found " + list_new + " size " + list_new.length);
						if (
							optimalSolution.length == 0 ||
							list_new.length < optimalSolution.length
						) {
							// console.log("SET");
							console.log("BEST >> " + list_new + " size " + list_new.length);
							optimalSolution = list_new; //reach target, return this set
						}
						found = true;
					} else if (left > 0) {
						recur_addCoin(list_new, coins, c, left); //more coin needed, GO ON
						found = true;
					}
				}
			}
		}
		//
		if (!found) {
			memory_n[remain] = -1; //cannot reach this target "remain", set # of coin to -1
		}
	}

	// //set that acheive the value, index before it use memory
	function memorize(set) {
		var sum = 0;
		var sub = [];
		var n = 0;
		for (var s = set.length - 1; s >= 0; s--) {
			sum += set[s];
			sub.push(set[s]);
			n++;
			memory_n[sum] = n;
			memory_set[sum] = sub;
		}
	}
	//-------------------------

	function BuildResult() {
		var txt = "";
		var txt2 = "";
		var txt3 = "";
		var part1 = [];
		var part2 = [];
		txt += txt_time;
		txt += Timer.reachLimit() ? " (limited)\n" : "\n";

		if (way < 1) {
			txt += "No possible way";
		} else {
			txt += way == 1 ? "Possible ways: 1" : "Possible ways: " + way;
			txt2 += " (N: " + optimalSolution.length + ")";
			var txtO = optimalSolution + "";
			// txt3 += txtO.match(/.{1,20}/g).join(" ");
			// txt3 = txt3 == "" ? "{ }" : txt3;
			// txt3 += T.strPrint_splitSpaceEveryN(txtO, ",", 5);
			// txt3 = txt3 == "" ? "{ }" : "{ " + txt3 + " } is the optimal set, or one of them";
			// txt3 += T.strPrint_splitSpaceEveryN(txtO, ",", 5);
			txt3 = T.arr_getFrequency_print(txtO.split(","),"x",", ",true);
			txt3 = txt3 == "" ? "[ ]" : "[ " + txt3 + " ] is the optimal set, or one of them";
			part2 = Template.simple_title_sub_content("key2", "Optimal Set of Coins", txt2, txt3, 20, 20);
		}
		part1 = Template.simple01("key1", "Result", txt, 22, 22);
		//------------------------
		partResultChange(
			<div>
				<div>{part1} </div>
				<br />
				<div>{part2} </div>
			</div>
		);
	}

	return (
		<GUIset_2Input
		title={"Coin Change (Change-making problem)"}
		desc={
			"How many ways can we make the change, and what is the minimum number of coins that add up to a given amount of money?"
		}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"Amount"}
			label2={"Coins"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={true}
			numberOnly2={false}
			txtButton={"Calculate"}
			style={1}
		/>
	);
};

export default Coin;

// //VER 1 ====================================

// import React, { useState, useEffect } from "react";
// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// // import T from "./TheTool";// NOT WORK, old ver
// import T from "./TheTool";
// import Timer from "./TheTimer";

// //oldest page
// const Coin = () => {
// 	useEffect(() => {
// 		document.title = "Coin Change (Change-making problem)";
// 	}, []);

// 	// const [guiTxt1, guiTxtChange1] = useState(13217); //int
// 	// const [guiTxt2, guiTxtChange2] = useState("1000,500,100,50,10,5,1");
// 	// const [guiTxt1, guiTxtChange1] = useState("4"); //int
// 	// const [guiTxt2, guiTxtChange2] = useState("1,2,3");
// 	// const [guiTxt1, guiTxtChange1] = useState("10"); //int
// 	// const [guiTxt2, guiTxtChange2] = useState("2,3,5,6");
// 	const [guiTxt1, guiTxtChange1] = useState("77"); //int
// 	const [guiTxt2, guiTxtChange2] = useState("63,55,48,41,30,29,17,15,12,8,1");
// 	//----
// 	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

// 	//https://www.geeksforgeeks.org/coin-change-dp-7/
// 	// function buttonClick1 () {
// 	const buttonClick1 = () => {
// 		if (guiTxt1 != "" && guiTxt2 != "") {
// 			// startTime = performance.now();
// 			// timeReachLimit = false;
// 			//----------------------
// 			var coins = T.str_toListInt(guiTxt2);
// 			var target = parseInt(guiTxt1);
// 			Timer.start();
// 			process(coins, target);
// 			txt_time = Timer.stop_print();
// 			//--------------------------
// 			// var endTime = performance.now();
// 			// txt_time = `Processing time ${endTime - startTime} ms`;
// 			BuildResult();
// 		}
// 	};

// 	var txt_time = "";
// 	// var startTime;
// 	// var timeAllow = 2999;
// 	// var timeReachLimit = false;
// 	//--------------
// 	var way = 0;
// 	// var listSolutions; //List<ArrayList<Integer>> //final result
// 	var optimalSolution = [];

// 	//Parallel, index is target value
// 	var memory_n; //int # of coin needed
// 	var memory_set; //List<int> set of coin

// 	function process(coins, target) {
// 		// process(coins, target);
// 		// BuildResult();
// 		// console.log("INPUT " + coins + "_" + target);
// 		// console.log("RRR " + GetResult(arr, m, n));
// 		// console.log("AAA " + T.test());
// 		// console.log("MIN " + coinChange(coins, target));
// 		// console.log("List " + set_optimal);
// 		//
// 		way = getNumberOfWays(target, coins);
// 		console.log("# of WAY " + way);
// 		if (way > 0) {
// 			// var ans = coinChange(coins, target);
// 			// console.log("MIN " + ans.n);
// 			// console.log("List " + ans.set);
// 			// console.log("List " + optimalSolution);
// 			findCoins(coins, target);
// 		}
// 	}

// 	//NEW solution -----------
// 	const getNumberOfWays = (N, Coins) => {
// 		// Create the ways array to 1 plus the amount to stop overflow
// 		let ways = new Array(N + 1);
// 		for (let i = 0; i < N + 1; i++) {
// 			ways[i] = 0;
// 		}
// 		// Set the first way to 1 because its 0 and there is 1 way to make 0 with 0 coins
// 		ways[0] = 1;
// 		// Go through all of the coins
// 		for (let i = 0; i < Coins.length; i++) {
// 			// Make a comparison to each index value of ways with the coin value.
// 			for (let j = 0; j < ways.length; j++) {
// 				if (Coins[i] <= j) {
// 					ways[j] += ways[j - Coins[i]];
// 				}
// 			}
// 		}
// 		return ways[N];
// 	};

// 	//---------

// 	//int[] coins, int target
// 	function findCoins(coins, target) {
// 		var listCoins = T.listSort_desc(coins); //Arrays.sort(coins, Collections.reverseOrder());//biggest coin first
// 		// console.log("COIN " + listCoins);
// 		// listSolutions = []; //List<ArrayList<Integer>> all = new ArrayList<ArrayList<Integer>>();//Each item = possible set of coins
// 		optimalSolution = [];
// 		memory_n = new Array(target + 1).fill(0);
// 		memory_set = new Array(target + 1).fill([]);
// 		recur_addCoin([], listCoins, 0, target); //List<ArrayList<Integer>> all;//Each item = possible set of coins
// 		// for (const a of listSolutions) {console.log(a);}
// 		// console.log("CHECK " + listCoins.length + "__" + listSolutions.length);
// 		// console.log("List " + memory_set[target]);
// 		// console.log("List " + optimalSolution);
// 	}

// 	//This function not return
// 	//INPUT: list of coin now, list of all coins (sorted High to Low), amount remain
// 	//List<ArrayList<Integer>> all, ArrayList<Integer> list, Integer[] coins, int remain
// 	//coin_i help skipping too large coin (next coin but not larger than last coin the list)
// 	function recur_addCoin(list, coins, coin_i, remain) {
// 		//Check time out first
// 		// if (timeReachLimit || performance.now() - startTime > timeAllow) {
// 		// 	timeReachLimit = true;
// 		// 	return;
// 		// }
// 		if (Timer.timeout()) {
// 			return;
// 		}
// 		//check remain amount in memory ----------------------------
// 		var opt_n = memory_n[remain];
// 		// console.log("test " + opt_n + " vs " + list.length);
// 		if (remain < 0) {
// 			return;
// 		}
// 		if (remain != 0) {
// 			if (opt_n < 0) {
// 				return; //unreachable
// 			}
// 			if (opt_n > 0) {
// 				// found data
// 				list.push(memory_set);
// 				remain = 0;
// 				console.log("call " + list);
// 			}
// 		}
// 		if (remain == 0) {
// 			// console.log("Found " + list + " size " + list.length);
// 			if (optimalSolution.length == 0 || list.length < optimalSolution.length) {
// 				// console.log("SET");
// 				console.log("BEST " + list + " size " + list.length);
// 				optimalSolution = list; //reach target, return this set
// 			}

// 			memorize(list);
// 			// found = true;
// 		}
// 		//---------------------------------------------------------
// 		// if(opt > 0 && opt < list.length - 2){ console.log("SKIP"); return; }
// 		// console.log("GO ON");
// 		var found = false;
// 		for (var c = coin_i; c < coins.length; c++) {
// 			var x = coins[c];
// 			if (x <= remain) {
// 				var lastCoin = list[list.length - 1];
// 				if (list.length == 0 || x <= lastCoin) {
// 					//only if list is empty, or this coin is not bigger than the last coin
// 					// var list_new = list.slice().push(coins[c]); //ERROR
// 					// var list_new = list.slice();
// 					// list_new.push(coins[c]); //clone and add 1 new
// 					var list_new = T.listAdd(list, coins[c]);
// 					var left = remain - coins[c];
// 					// console.log("REMAIN " + remain + "-" + coins[c] + " >> " + left);
// 					//--------------------------------
// 					if (left == 0) {
// 						// console.log("Found " + list_new + " size " + list_new.length);
// 						if (
// 							optimalSolution.length == 0 ||
// 							list_new.length < optimalSolution.length
// 						) {
// 							// console.log("SET");
// 							console.log("BEST >> " + list_new + " size " + list_new.length);
// 							optimalSolution = list_new; //reach target, return this set
// 						}
// 						found = true;
// 					} else if (left > 0) {
// 						recur_addCoin(list_new, coins, c, left); //more coin needed, GO ON
// 						found = true;
// 					}
// 				}
// 			}
// 		}
// 		//
// 		if (!found) {
// 			memory_n[remain] = -1; //cannot reach this target "remain", set # of coin to -1
// 		}
// 	}

// 	// //set that acheive the value, index before it use memory
// 	function memorize(set) {
// 		var sum = 0;
// 		var sub = [];
// 		var n = 0;
// 		for (var s = set.length - 1; s >= 0; s--) {
// 			sum += set[s];
// 			sub.push(set[s]);
// 			n++;
// 			memory_n[sum] = n;
// 			memory_set[sum] = sub;
// 		}
// 	}

// 	//-------------------------

// 	function BuildResult() {
// 		var txt = "";
// 		var txt2 = "";
// 		var txt3 = "";
// 		var part1 = [];
// 		var part2 = [];
// 		//------------------------
// 		// if (timeReachLimit) {
// 		// 	txt += txt_time + " (limited)\n";
// 		// } else {
// 		// 	txt += txt_time + "\n";
// 		// }
// 		txt += txt_time;
// 		txt += Timer.reachLimit() ? " (limited)\n" : "\n";

// 		if (way < 1) {
// 			txt += "No possible way";
// 		} else {
// 			if (way == 1) {
// 				txt += "Possible ways: 1";
// 			} else {
// 				txt += "Possible ways: " + way;
// 			}
// 			// txt += "\n";
// 			//---------
// 			txt2 += " (N: " + optimalSolution.length + ")";
// 			// txt += "\n" + "Optimal set: " + optimalSolution;
// 			var txtO = optimalSolution + "";
// 			// txt3 += txtO.match(/.{1,20}/g).join(" ");
// 			txt3 += T.listPrint_splitSpaceEveryN(txtO, ",", 5);
// 			if (txt3 == "") {
// 				txt3 = "{ }";
// 			}
// 			// txt += "sssssssssssssssssssssssssssssssss ssssssssssssssssssssssssss ssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss";
// 			part2 = [
// 				<div key="part2">
// 					<br />
// 					<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>
// 						<b>Optimal Set</b> {txt2}
// 					</div>
// 					<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt3}</div>
// 				</div>,
// 			];
// 		}
// 		part1 = [
// 			<div key="part1">
// 				<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
// 					<h2>Result</h2>
// 				</div>
// 				<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt}</div>
// 			</div>,
// 		];
// 		//------------------------
// 		partResultChange(
// 			<div>
// 				<div>{part1} </div>
// 				<div>{part2} </div>
// 			</div>
// 		);
// 		// partResultChange(
// 		//     <div>
// 		//     	<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
// 		//     		<h2>Result</h2>
// 		//     	</div>
// 		//     	<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt}</div>
// 		//     	<br />
// 		//     	<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>
// 		//     		<b>Optimal Set</b> {txt2}
// 		//     	</div>
// 		//     	<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt3}</div>
// 		//     </div>
// 		// );
// 	}

// 	//--------------------------------------------------------

// 	return (
// 		<div className="todoapp stack-large">
// 			<GUI_Header
// 				title={"Coin Change (Change-making problem)"}
// 				desc={
// 					"How many ways can we make the change, and what is the minimum number of coins that add up to a given amount of money?"
// 				}
// 			/>
// 			<div style={{ marginTop: "3em" }}> </div>
// 			<GUI_InputTextSingle
// 				label={"Amount"}
// 				text1={guiTxt1}
// 				text1Change={guiTxtChange1}
// 				numberOnly={true}
// 				fontSize2={28}
// 				width1={120}
// 				width2={'80%'}
// 			/>
// 			<GUI_InputTextSingle
// 				label={"Coins"}
// 				text1={guiTxt2}
// 				text1Change={guiTxtChange2}
// 				numberOnly={false}
// 				fontSize2={22}
// 				width1={120}
// 				width2={'80%'}
// 			/>
// 			<div style={{ display: "flex", marginLeft: '20%', marginRight: '5%' }}>
// 				<button
// 					onClick={() => buttonClick1()}
// 					className="btn btn__primary btn__lg"
// 					style={{ flex: 1, height: 50 }}
// 				>
// 					Calculate
// 				</button>
// 			</div>
// 			<div style={{ marginTop: "3em" }}> </div>
// 			{partResult}
// 			{/* {GetResult()} */}
// 			<GUI_Credit />
// 		</div>
// 	);
// };

// export default Coin;
